import React, { Component } from 'react';
import {Dropdown} from 'react-bootstrap';
import { getAuth, onAuthStateChanged } from "firebase/auth"

import DEMO from "../../../store/constant";

import Avatar1 from '../../../assets/images/user/avatar-1.jpg';

import { signOutUser } from "../../../apis/user"
import config from '../../../config';

class NavRight extends Component {

    constructor(props) {
        super(props)
        this.state = {
            listOpen: false,
            user: null
        };
    }


    componentDidMount() {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                this.setState({user})
            } else {
              // User is signed out
            }
          });
    }

    signOutUser = async () => {
        const confirmStr = "Are you sure, you want to sign out?"
        if (window.confirm(confirmStr)) {
            await signOutUser()
            window.location.reload()
        }
    }
    render() {

        const { state, signOutUser } = this

        return (
            <React.Fragment>
                <ul className="navbar-nav ml-auto">
                    <li>
                        <Dropdown alignright="true" className="drp-user">
                            <Dropdown.Toggle variant={'link'} id="dropdown-basic">
                                <i className="icon feather icon-settings"/>
                            </Dropdown.Toggle>
                            <Dropdown.Menu alignright className="profile-notification">
                                <div className="pro-head">
                                    <img src={Avatar1} className="img-radius" alt="User Profile"/>
                                    <span>{ state?.user?.email === config.USER ? 'User' : 'Admin User'}</span>
                                    <a onClick={signOutUser} href="javascript:void(0)" className="dud-logout" title="Sign Out">
                                        <i className="feather icon-log-out"/>
                                    </a>
                                </div>
                                <ul className="pro-body">
                                    <li><a href={DEMO.BLANK_LINK} className="dropdown-item"><i className="feather icon-user"/> Profile</a></li>
                                </ul>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}

export default NavRight;
